"use strict";

exports.__esModule = true;
exports.default = void 0;

var _emotion = require("emotion");

var base = /*#__PURE__*/(0, _emotion.css)("box-sizing:border-box;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-moz-font-feature-settings:'liga' on;*,*:after,*:before{box-sizing:border-box;}");
var _default = base;
exports.default = _default;